import fayeClient from './fayeClient';

/**
 * Security API - handles session management.
 * Login itself is done via authApi (email + passcode over apiClient).
 */
const securityApi = {
  /**
   * Check if user is logged in and get session info
   */
  checkSession() {
    const msg = {
      messageType: 'check-session'
    };
    return fayeClient.sendToFaye('/security', msg, '/security-data/');
  },

  /**
   * Logout current user
   * This triggers a page redirect on the backend
   */
  async logout() {
    // The logout is handled by redirecting to /logout endpoint
    window.location.href = '/logout';
  }
};

export default securityApi;
